var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBusinessNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.573 19.53l-3.81-3.81-1.02-1.02c-.264-.265-.784-.48-1.158-.48h-.28L16.9 18.4l-.27-3.38h-1.26l-.27 3.38-1.405-4.18h-.28c-.372 0-.894.215-1.158.48l-1.02 1.02-3.81 3.81a1.431 1.431 0 00-.264 1.653c.066.136.15.266.264.379.113.112.242.196.378.264a1.43 1.43 0 001.654-.264l2.798-2.8c.264-.263.48-.175.48.199v4.988c0 .32.23.58.532.648v.029h5.462v-.03a.671.671 0 00.533-.647V18.96c0-.374.215-.462.479-.199l2.798 2.8c.45.448 1.118.532 1.655.264a1.45 1.45 0 00.377-.264c.112-.113.196-.243.264-.379a1.43 1.43 0 00-.264-1.653M17.898 13.212c.673-.718 1.007-1.323 1.007-2.935A2.788 2.788 0 0016 7.372a2.785 2.785 0 00-2.092.814 2.794 2.794 0 00-.815 2.09c0 1.613.335 2.218 1.008 2.936.617.45 1.275.514 1.899.514.622 0 1.28-.064 1.897-.514"
  })))));
}

export default SvgIconBusinessNew;